import { render, staticRenderFns } from "./DeliveryPlanningTable.vue?vue&type=template&id=2c2f8fbe&"
import script from "./DeliveryPlanningTable.vue?vue&type=script&lang=js&"
export * from "./DeliveryPlanningTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports